import * as React from 'react';

const HSeperator = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={1} height={14} fill="none" {...props}>
        <path stroke="#8D8D8D" d="M.5 0v14" />
    </svg>
);
export default HSeperator;
